import React, { useState } from 'react';
import IconBtn from '../../../../Components/IconBtn';
import Dropdown from '../../../../Components/Dropdown';
import Listbox from '../../../../Components/Listbox';
import ListboxItem from '../../../../Components/ListboxItem';

interface Category {
  name: string;
  label: string;
  value: string;
  cat1: string;
  cat2: string;
}

interface SelectByTypeCategoriesProps {
  changeCategorySelected: (category: Category) => void;
  categories?: Category[];
}

const SelectByTypeCategories: React.FC<SelectByTypeCategoriesProps> = ({
	changeCategorySelected,
	categories,
}) => {
	
	const [isOpen, setIsOpen] = useState(false);

	function handleSelectCategorySelection(category: Category) {
		changeCategorySelected(category);
		setIsOpen(false);
	}

	if (!categories) {
		return null;
	}

	return (
		<>
			<Dropdown
				isOpen={isOpen}
				toggle={(s) => setIsOpen(s)}
				scrollbar={true}
				button={
					<IconBtn
						icon="fas fa-crosshairs"
						tooltip="Quick access to a category page"
					/>
				}
			>
				<div className='dropdown_header mb_5 fw_medium'>Quick access to a category page</div>
				<Listbox>
					{categories.map((cat) => 
						<ListboxItem
							key={cat.value}
							message={cat.label}
							onClick={() => handleSelectCategorySelection(cat)}
							hasArrow={true}
						/>
					)}
				</Listbox>
			</Dropdown>
		</>
	);
};

export default SelectByTypeCategories;